import moment from 'moment'
import React from 'react'

import styles from './index.module.css'

type Props = {
  date: string
  onChange: (date: string) => void
}

export const DateNavigator: React.FC<Props> = ({ date, onChange }) => {
  const m = moment(date)
  const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][m.day()]

  const handlePrev = () => {
    onChange(m.clone().subtract(1, 'day').format('YYYY-MM-DD'))
  }

  const handleNext = () => {
    onChange(m.clone().add(1, 'day').format('YYYY-MM-DD'))
  }

  return (
    <div className={styles.wrapper}>
      <button className={styles.navButton} onClick={handlePrev}>
        ◀
      </button>
      <span className={styles.dateLabel}>
        {m.format('YYYY/MM/DD')}({dayOfWeek})
      </span>
      <button className={styles.navButton} onClick={handleNext}>
        ▶
      </button>
    </div>
  )
}
